import {
  InquiryPlateQueryParamsType,
  InquiryPlateResultType,
} from '@/common/queries/inquiryPlate/inquiryPlateQuery.type';
import { inquiryPlateQueryFunction } from '@/common/queries/inquiryPlate/inquiryPlateQueryFunction';
import { MutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

export const InquiryPlateQueryOption = (): MutationOptions<
  AxiosResponse<string, string> | InquiryPlateResultType,
  Error,
  InquiryPlateQueryParamsType
> => {
  return {
    mutationKey: ['Inquiry_Plate'],
    mutationFn: inquiryPlateQueryFunction,
  };
};
